var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<web-component> <page-header title=\"title\" subtitle=\"subtitle\" image=\"image\"> </page-header> </web-component>";
var id1="winresOmalomaPageHeader.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresOmalomaPageHeader/winresOmalomaPageHeader.html
// module id = 348
// module chunks = 2